var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex pb-2 flex-row"},[_c('div',{staticClass:"flex flex-1",class:{
      'flex-grow-2': _vm.columns === '2',
      'flex-grow': _vm.columns !== '2',
    }},[_vm._t("first")],2),_c('div',{staticClass:"flex flex-1 pl-3 flex-grow"},[_vm._t("second")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }